import Frog from '@fenbi/frog'
import { frogUrl } from '@/service/request'

window.localStorage && window.localStorage.removeItem('_fr_g_')

const install = Vue => {
  Vue.prototype.$addFrog = function(productId, url, keyValues) {
    keyValues = keyValues || []
    const ins = new Frog({
      url: frogUrl,
      maxCount: 10,
      productId: productId,
      keyValues,
    })
    ins.add(url)
  }
}

export default { install }
